import {Component, Input, OnInit} from '@angular/core';
import {FormControl} from '@angular/forms';
import {MatChipInputEvent} from '@angular/material/chips';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Config} from "../../../modules/sidebar/sidebar.component";
import {NavbarConfig} from "../../../modules/navbar/navbar.component";
import {last} from "rxjs/operators";

@Component({
  selector: 'app-chips-input-control',
  templateUrl: './chips-input-control.component.html',
  styleUrls: ['./chips-input-control.component.scss']
})
export class ChipsInputControlComponent implements OnInit {

  constructor(private snack: MatSnackBar) { }
  @Input() label: string;
  @Input() placeholder: string;
  @Input() arrayControl: FormControl;
  @Input() required = false;
  @Input() validationMessage?: string;
  @Input() pipe?: any = null;
  @Input() lastTest  = false;

  readonly separatorKeysCodes: number[] = [ENTER, COMMA];

  @Input() validationFunction = (value: string): boolean => {
    return true;
  }

  ngOnInit(): void {
    if (this.arrayControl.value.length > 0 && this.lastTest.valueOf() === true) {
      this.arrayControl.value.splice(0, this.arrayControl.value.length - 1);
   }
  }

  remove(value: string): void {
    const index = this.arrayControl.value.indexOf(value);

    if (index >= 0) {
      this.arrayControl.value.splice(index, 1);
      this.arrayControl.updateValueAndValidity();
    }
  }

  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    if (value.trim() === null || value.trim() === '') {
      return;
    }

    if (!this.validationFunction(value)) {
      this.snack.open(this.validationMessage, '', {
        duration: 2000,
      });
      return;
    }

    if ((value || '').trim()) {
      this.arrayControl.setValue([...this.arrayControl.value, value.trim()]);
      this.arrayControl.updateValueAndValidity();
    }

    if (input) {
      input.value = '';
    }
  }
}
